import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { AbstractControl } from '@angular/forms';
import {
  ITrackingObject,
  ITrackingAction,
} from '../../../tracking/tracking.data';
import { TrackingDispatcher } from '../../../tracking/tracking.dispatcher';

@Component({
  selector: 'app-radio-field',
  templateUrl: 'radio-field.component.html',
  styleUrls: ['radio-field.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RadioFieldComponent {
  @Input() label: string;
  @Input() group: string;
  @Input() hideLabel: boolean;
  @Input() fieldId: string;
  @Input() value: string;
  @Input() e2eId: string;
  @Input() description: string;
  @Input() fieldControl: AbstractControl;
  @Input() trackingObject: ITrackingObject;
  @Input() trackingTapped: ITrackingAction;

  @Output() onClick: EventEmitter<Event> = new EventEmitter<Event>();

  constructor(private _trackingDispatcher: TrackingDispatcher) {}

  onRadioClick(event: Event) {
    if (this.fieldControl && this.trackingObject && this.trackingTapped) {
      this._trackingDispatcher.trackEvent(
        this.trackingObject,
        this.trackingTapped.setValue(this.value)
      );
    }

    this.onClick.emit(event);
  }
}
